import {crc16modbus} from "crc";

/**
 * 通过字符串计算crc16 并转换为字符串
 * @param {string} str 字符串
 * @returns {string}
 */
function calculateCrcAndConvert(str) {
  let typedArray = new Uint8Array(str.match(/[\da-f]{2}/gi).map(function (h) {
    return parseInt(h, 16)
  }))
  let crc = crc16modbus(typedArray.buffer).toString(16);
  return convertString(crc);
}

/**
 *
 * @param {string} input 需转的字符串
 * @returns {string}
 */
function convertString(input) {
  // 将输入转换为大写并去除空格
  input = input.toUpperCase().replace(/ /g, "");
  // 如果输入长度小于4，前面补0直到长度为4
  while (input.length < 4) {
    input = "0" + input;
  }
  // 交换位置
  const temp = [input[2], input[3], input[0], input[1]];
  return temp.join("");
}

/**
 * 获取协议代码
 * @param {string} prefix 协议代码前缀
 * @return {string}
 */
export default function getProtocolCode(prefix) {
  if(!prefix || typeof prefix !== "string") return "";
  const result = calculateCrcAndConvert(prefix)
  return prefix + result + "ef";
}



